<template>
    <span>
    <el-cascader ref="townSelect" :options="townTree"  v-model="select"  @change="parentChange" filterable></el-cascader>
    </span>

</template>
<script>

import {getTree} from '@/api/admin/sysBaseTown/index';
export default {
  components: {},
  props: ["noType",'selectValue'],
  data() {
    return {
      townTree:[],
      select:[]
    }
  },
  computed: {
  },
  watch: {},
  created() {

  },
  mounted() {
      this.selectTownList();
  },
  methods: {
    selectTownList() {
      getTree({parentId: -1,noType: this.noType}).then(response=>{
        this.townTree = response;
        this.computedSelect();
      })
    },
    parentChange(selectIds){
      this.$emit("on-select", selectIds);
      this.$emit("on-selectLast", selectIds[selectIds.length-1]);
      let list = this.$refs.townSelect.getCheckedNodes();
      console.log("选择了", list[0].pathLabels)
      this.$emit("on-labels", list[0].pathLabels);
    },
    computedSelect(){
      let selectValue = this.selectValue;
      let tree = this.townTree;
      if(!selectValue || !tree)return;
      top:
          for(let i=0;i<tree.length;i++){
            let A = tree[i].children;
            if(tree[i].id==selectValue){
              this.select = [tree[i].id];
              break top;
            }
            if(A) {
              for (let j = 0; j < A.length; j++) {
                let B = A[j].children;
                if (A[j].id == selectValue) {
                  this.select = [tree[i].id, A[j].id];
                  break top;
                }
                if (B) {
                  for (let k = 0; k < B.length; k++) {
                    if (B[k].id == selectValue) {
                      this.select = [tree[i].id, A[j].id, B[k].id];
                      break top;
                    }
                  }
                }
              }
            }
          }
    }
  }
}

</script>
<style>

</style>
